import {daliEsSystemConstants} from "../constants/dali-es-system.constants";

const initEsSystemState = {
    esSystemAreaList: null,
    esSystemAreaItem: null,
    esSystemGroupList: null,
    esSystemGroupItem: null,
    esSystemSceneList: null,
    validationForm: null,
    groupFromDevice: null
};

export function daliEsSystemReducer(state = initEsSystemState, action) {
    switch (action.type) {
        case daliEsSystemConstants.ES_SYSTEM_GROUP_LIST_REQUEST:
        case daliEsSystemConstants.ES_SYSTEM_GROUP_LIST_FAILURE:
        case daliEsSystemConstants.ES_SYSTEM_SCENE_LIST_REQUEST:
        case daliEsSystemConstants.ES_SYSTEM_SCENE_LIST_FAILURE:
        case daliEsSystemConstants.ES_SYSTEM_AREA_LIST_REQUEST:
        case daliEsSystemConstants.ES_SYSTEM_AREA_LIST_FAILURE:
        case daliEsSystemConstants.ES_SYSTEM_AREA_ITEM_REQUEST:
        case daliEsSystemConstants.ES_SYSTEM_AREA_ITEM_FAILURE:
        case daliEsSystemConstants.ES_SYSTEM_CLEAR:
            return {
                esSystemAreaList: null,
                esSystemAreaItem: null,
                esSystemGroupList: null,
                esSystemGroupItem: null,
                esSystemSceneList: null,
                validationForm: null,
                groupFromDevice: null
            };
        case daliEsSystemConstants.ES_SYSTEM_GROUP_LIST_SUCCESS:
            return {
                ...state,
                esSystemGroupList: action.groupsModel,
                validationForm: null
            };
        case daliEsSystemConstants.ES_SYSTEM_GROUP_ITEM_SUCCESS:
            return {
                ...state,
                esSystemGroupItem: action.groupItem,
                validationForm: null
            };
        case daliEsSystemConstants.ES_SYSTEM_SCENE_LIST_SUCCESS:
            return {
                ...state,
                esSystemSceneList: action.scenesModel,
                validationForm: null
            };
        case daliEsSystemConstants.ES_SYSTEM_AREA_LIST_SUCCESS:
            return  {
                ...state,
                esSystemAreaList: action.areaModel,
                validationForm: null
            };
        case daliEsSystemConstants.ES_SYSTEM_AREA_ITEM_SUCCESS:
            return  {
                ...state,
                esSystemAreaItem: action.areaSingleModel,
                validationForm: null
            };
        case daliEsSystemConstants.ES_SYSTEM_GET_GROUPS_FROM_DEVICE_SUCCESS:
            return  {
                ...state,
                groupFromDevice: action.groups
            };
        case daliEsSystemConstants.ES_SYSTEM_GET_GROUPS_FROM_DEVICE_FAILURE:
            return {
                ...state,
                groupFromDevice: "error"
            };
        case daliEsSystemConstants.ES_SYSTEM_GET_GROUPS_FROM_DEVICE_CLEAR:
            return  {
                ...state,
                groupFromDevice: null
            };
        case daliEsSystemConstants.ES_SYSTEM_VALIDATION_FORM: {
            return {
                ...state,
                validationForm: action.error.response.data
            };
        }
        default: {
            return  state
        }
    }
}


